<template>
	<div :class="['salaryHistorySlide', isLatestDate ? 'autumn' : 'winter']" dir="ltr">
		<div class="title">
			<svg-sprite icon-id="calendarAlt" color="#1dab39"></svg-sprite>
			{{ item.month }}
			<span class="subText">{{ monthDateStart() }} - {{ monthDateEnd() }}</span>
		</div>
		<div class="tableWrap">
			<div class="tableName">
				<div class="text">Payroll</div>
			</div>
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeadersAccrual"
					:listItems="item.payroll"
					@updateClickButton="onClickButton($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="5"
					:pages="[ 5, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
		<div class="tableWrap">
			<div class="tableName">
				<div class="text">Salary payment</div>

				<button v-if="isLatestDate && isPay" @click="onPay" :disabled="isPayPerm">
					<svg-sprite icon-id="icon-pay"></svg-sprite>
					<span class="text">Pay</span>
				</button>
			</div>
<!--			.reverse()-->
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeadersPay"
					:listItems="item.salary_payment"
					@updateClickButton="onClickButton($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="5"
					:pages="[ 5, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>

		<div class="down">
			<div class="rowWrap">
				<item-info-row
						icon-id="MoneyReceive"
						text="Balance:"
						:value="balance"
						is-value-first-icon
						value-first-icon="icon_dollars"
						value-first-icon-width="8"
						value-first-icon-height="16"
						:is-item-value="!!balance"
						customClass="extraBigValue valueGreen"
				></item-info-row>
				<tool-tip-question
						v-if="!balance"
						text="There is no balance"
				></tool-tip-question>
			</div>
		</div>
	</div>
</template>

<script>

import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";

// import { salaryHistorySlideAccrual, salaryHistorySlidePay, salaryHistorySlidePayAdmin } from "@/pages/Account/constants";
import { salaryHistorySlideAccrual, salaryHistorySlidePayAdmin } from "@/pages/Account/constants";
import ToolTipQuestion from "@/shared/ToolTipQuestion/ToolTipQuestion.vue";
import { mapGetters } from "vuex";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "SalaryHistorySlide",
	components: { ToolTipQuestion, ItemInfoRow },
	computed: {
		...mapGetters([
			'role', 'permissionsDefault'
		]),
		getHeadersAccrual() {
			return salaryHistorySlideAccrual;
		},
		getHeadersPay() {
			// return this.role === 3 ? salaryHistorySlidePayAdmin : salaryHistorySlidePay;
			return salaryHistorySlidePayAdmin;
		},
		isLatestDate() {
			const dates = this.months.map(item => new Date(item.date));
			const latestDate = new Date(Math.max(...dates));
			return new Date(this.item.date).getTime() === latestDate.getTime();
		},
		isPayPerm() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_SALARY_HISTORY, PERMISSIONS.CREATE ];
			return !getPermissionsMod({ list, path });
		},
	},
	props: {
		item: Object,
		months: Array,
		flag: {
			type: String,
			default: 'salaryHistorySlide'
		},
		isPay: {
			type: Boolean,
			default: true
		},
	},
	data: () => ({
		balance: null,
	}),

	methods: {
		updateBalance(balance) {
			return balance ? parseFloat(balance).toFixed(2) : null;
		},
		formatDate(date) {
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${ month }.${ day }`;
		},
		monthDateStart() {
			const myDate = new Date(this.item.date);
			return this.formatDate(myDate);
		},
		monthDateEnd() {
			const myDate = new Date(this.item.date);
			myDate.setDate(myDate.getDate() + 28);
			return this.formatDate(myDate);
		},
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateEditItem', { key, item, nameComponent });
		},
		onPay() {
			const item = this.item;
			this.$emit('updatePay', { item });
		},
	},
	mounted() {
		if (this.item) {
			const { balance } = this.item;
			this.balance = this.updateBalance(balance);
		}
	},
	watch: {
		item(value, oldValue) {
			if (value !== oldValue) {
				const { balance } = value;
				this.balance = this.updateBalance(balance);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.salaryHistorySlide {
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 20px;
	background: rgba(255, 255, 255, 0.01);
	.title {
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 10px;
		margin-bottom: 4px;
		.subText {
			color: gray;
			font-size: 12px;
		}
	}
	&.spring {
		.title {
			background-color: rgba(255, 251, 0, 0.1);
		}
	}
	&.summer {
		background: rgba(255, 255, 255, 0.05);
		.title {
			background-color: rgba(22, 255, 0, 0.1);
		}
	}
	&.autumn {
		background: rgb(180 165 0 / 5%);
		.title {
			background-color: rgba(255, 128, 0, 0.1);
		}
	}
		&.winter {
		.title {
			background-color: rgba(255, 255, 255, 0.1);
		}
	}
	.tableWrap {
 		.tableName {
		  color: #1dab39;
		  font-size: 14px;
		  margin-bottom: 6px;
		  display: flex;
		  align-items: center;
		  justify-content: space-between;
		  gap: 10px;
		  button {
			  padding: 10px;
			  background-color: #ff8f00;
			  color:#2c2c2c;
			  border: none;
			  border-radius: 3px;
			  cursor: pointer;
			  display: flex;
			  align-items: center;
			  justify-content: center;
			  gap: 4px;
			  transition: 0.3s;
			  &:hover {
				  background-color: #ffad46;
				  color:#2c2c2c;
			  }
			  &:disabled {
				  opacity: 0.5;
				  cursor: default;
				  background-color: #d2d2d2;
				  color: var(--card-color);
				  &:hover {
					  background-color: #d2d2d2;
					  color: var(--card-color);
				  }
			  }
		  }
		}
	}
	
	.rowWrap {
		display: flex;
		align-items: center;
		gap: 4px;

		.itemInfo {
			flex: 2 0;
		}

		.btnWrapper {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}

}
</style>
